
import {Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ARService } from '../../ar.service';
import {MessagingService} from '../../../../services/messaging.service';
import { ITDOPaymentTransactionResult, TDO_PAYMENT_TRANSACTION_MODE } from '@tdo-inc/tdo-payment';
import { DialogService } from 'src/app/services/dialog.service';
import { Console } from 'console';


@Component({
    selector: 'app-ar-card-payment',
    templateUrl: './ar-card-payment.component.html',
    styleUrls: ['./ar-card-payment.component.css']
})
export class ArCardPaymentComponent implements OnInit {

    messagingSubscription: any;
    LOCID: string;
    isLoading: boolean = false;
    // transactionSetupID: string;
    paymentAmount: number = 0.0;
    // transactionSetupIDReceived: boolean = false;
    approvedPaymentAmount: number;
    paymentProcessorId: string;
    enterpriseId: string;
    transactionIdentifier: string;
    accountDescription: string;
    savePaymentInfo: number;

    accountId: string;
    accountToken: string;
    acceptorId: string;
    applicationId: string;
    payeeName: string;


    hasError: boolean = false;
    patientId: string;
    configurationError: string;

    transactionResult: ITDOPaymentTransactionResult = {
        id: null,
        success: false,
        message: 'Transaction Cancelled',
        data: null
    };
    public get TDO_PAYMENT_TRANSACTION_MODE() {
        return TDO_PAYMENT_TRANSACTION_MODE;
    }

    constructor(
        public dialogRef: MatDialogRef<ArCardPaymentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly arService: ARService,
        private readonly dialogService: DialogService,
    ) {
    }

    async ngOnInit() {

        this.paymentAmount = this.data.paymentAmount;
        this.patientId = this.data.arPayment.PatientId;
        this.payeeName = this.data.paymentFrom;
        this.accountDescription = this.data.accountDescription;
        this.paymentProcessorId = this.data.paymentProcessorID;
        this.enterpriseId = localStorage.getItem('TDOEnterpriseId');
        this.transactionIdentifier = this.enterpriseId.concat('-', this.data.arPayment.PaymetnID);
        this.savePaymentInfo = this.data.savePaymentInfo;
    }

    parseOrigin() {
        let origin = location.origin;

        if (origin.indexOf('https://') > -1) {
            origin = origin.replace('https://', '');
        }

        if (origin.indexOf('http://') > -1) {
            origin = origin.replace('http://', '');
        }

        if (origin.indexOf('.') > -1) {
            origin = origin.slice(0, origin.indexOf('.'));
        }

        if (origin.indexOf(':') > -1) {
            origin = origin.slice(0, origin.indexOf(':'));
        }

        origin = origin.trim();

        return origin;
    }


    close() {
        this.dialogRef.close(this.transactionResult);
    }

    onTransactionCompleted(event) {
        if (event?.success) {
            this.transactionResult = event;
            this.transactionResult.data.amount = this.paymentAmount;
            this.close();
        }
        else{
            this.isLoading = true;
            this.arService.getValPayPaymentStatus(this.data.arPayment.PaymetnID).subscribe((response) => {
                if (response){
                    this.transactionResult.success = response.Success;
                    this.transactionResult.message = response.Message;
                    this.dialogService.openConfirmDialog(`Error completing payment transaction:<br/><b>${response.Message}</b>`, false, false, 'Error in payment procesing').subscribe((result) => {
                        this.close();
                    });
                }
                this.isLoading = false;
            }, (error) => {
                console.log('Error on PaymentStatus request: ', error);
                this.isLoading = false;
            }, () => {
                console.log('Final on PaymentStatus request:');
                this.isLoading = false;
            });
        }
    }

}
